import { isOneOf } from 'utils/isOneOf';
import type { DeviceViewEdgeEntity } from '../deviceViewTypes';

export const isTargetGroupNode = (
  deviceViewEntity: DeviceViewEdgeEntity,
): boolean => isOneOf(deviceViewEntity.targetType, 'phoneGroup', 'hostGroup');
